import $ from 'jquery';
class FeeAnalysis {
    constructor(){
        if ($("#fee_analysis_event").length != 0){
            this.events();
        }
    }

    events() {
        var cancelledBox;
        var lateEntriesBox;
        var priceBox1;
        var priceBox2;
        var valid = true;
        this.dataLocked = true;
        if ($('#fb-data-locked').hasClass('d-none')){
            this.dataLocked = false;
        }
        //  Register Listeners only if on page
        $('#FB-single-std').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    cancelledBox = $('#fb_sh_std_cancelled');
                    lateEntriesBox = $('#fb_sh_std_late_entries');
                    priceBox1 = "";
                    priceBox2 = "";
                    valid = validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2);
                    if (valid){
                        $(this).dialog('close');
                        updateServer(
                            "SHSTD",
                            $('#fb_sh_std_cancelled').val(),
                            $('#fb_sh_std_late_entries').val(),
                            '',
                            ''
                        );
                    }
                },
                Cancel: function(){
                    $(this).dialog('close')
                },
            }
        });
        $('#FB-single-sub').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    cancelledBox = $('#fb_sh_sub_cancelled');
                    lateEntriesBox = $('#fb_sh_sub_late_entries');
                    priceBox1 = "";
                    priceBox2 = "";
                    valid = validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2);
                    if (valid){
                        $(this).dialog('close');
                        updateServer(
                            "SHSUB",
                            $('#fb_sh_sub_cancelled').val(),
                            $('#fb_sh_sub_late_entries').val(),
                            '',
                            ''
                        );
                    }
                },
                Cancel: function(){
                    $(this).dialog('close')
                }
            }
        });
        $('#FB-double-std').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    cancelledBox = $('#fb_dh_std_cancelled');
                    lateEntriesBox = $('#fb_dh_std_late_entries');
                    priceBox1 = "";
                    priceBox2 = "";
                    valid = validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2);
                    if (valid){
                        $(this).dialog('close');
                        updateServer(
                            "DHSTD",
                            $('#fb_dh_std_cancelled').val(),
                            $('#fb_dh_std_late_entries').val(),
                            '',
                            ''
                        );
                    }
                },
                Cancel: function(){
                    $(this).dialog('close')
                }
            }
        });
        $('#FB-boat-loan').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    cancelledBox = $('#fb_boat_loan_cancelled');
                    lateEntriesBox = $('#fb_boat_loan_late_entries');
                    priceBox1 = $('#fb_boat_loan_price');
                    priceBox2 = '';
                    valid = validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2);
                    if (valid){
                        $(this).dialog('close');
                        updateServer(
                            "BOATLOAN",
                            $('#fb_boat_loan_cancelled').val(),
                            $('#fb_boat_loan_late_entries').val(),
                            $('#fb_boat_loan_price').val(),
                            ''
                        );
                    }
                },
                Cancel: function(){
                    $(this).dialog('close')
                }
            }
        });
        $('#FB-club-subsidy').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    cancelledBox = '';
                    lateEntriesBox = '';
                    priceBox1 = $('#fb_subsidy_value');
                    priceBox2 = '';
                    valid = validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2);
                    if (valid){
                        $(this).dialog('close');
                        updateServer(
                            "SUBSIDY",
                            '',
                            '',
                            $('#fb_subsidy_value').val(),
                            ''
                        );
                    }
                },
                Cancel: function(){
                    $(this).dialog('close')
                }
            }
        });
        $('#FB-online-funds').dialog({
            autoOpen: false,
            modal: true,
            show: {
                effect: "fadeIn",
                duration: 500
            },
            hide: {
                effect: "fadeOut",
                duration: 500
            },
            buttons: {
                "Save": function(){
                    cancelledBox = '';
                    lateEntriesBox = '';
                    priceBox1 = $('#fb_dys_online_value');
                    priceBox2 = $('#fb_club_online_value');
                    valid = validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2);
                    if (valid){
                        $(this).dialog('close');
                        updateServer(
                            "ONLINE",
                            '',
                            '',
                            $('#fb_dys_online_value').val(),
                            $('#fb_club_online_value').val()
                        );
                    }
                },
                Cancel: function(){
                    $(this).dialog('close')
                }
            }
        });
        $('#FB-single-std').removeClass('d-none');
        $('#FB-single-sub').removeClass('d-none');
        $('#FB-double-std').removeClass('d-none');
        $('#FB-boat-loan').removeClass('d-none');
        $('#FB-club-subsidy').removeClass('d-none');
        $('#FB-online-funds').removeClass('d-none');
        $("#FB-single-handed-std-row").on("click", this.openSingleHandedStdDialog.bind(this));
        $("#FB-single-handed-sub-row").on("click", this.openSingleHandedSubDialog.bind(this));
        $("#FB-double-handed-std-row").on("click", this.openDoubleHandedStdDialog.bind(this));
        $("#FB-boat-loan-row").on("click", this.openBoatLoanDialog.bind(this));
        $("#FB-club-subsidy-row").on("click", this.openClubSubsidyDialog.bind(this));
        $("#FB-online-funds-row").on("click", this.openOnlineFundsDialog.bind(this));
        $("#FB-fees-bursary-row").on("click", this.toggleFeesBursaryData.bind(this));
        $("#FB-hire-bursary-row").on("click", this.toggleHireBursaryData.bind(this));
        $("#fb-lock-data").on("click", this.lockData.bind(this));
    }
    lockData(e){
        var restData = {
            "LOCK-DATA": $('#fb-title').data('fees-id'),
            "EVENT-ID": $('#fee_analysis_event').data('event')
        }
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/lockFeesData/',
            data: restData,
            type: 'POST',
            success: (response) =>{
                if (response!="FAILED"){
                    $('#fb-data-locked').removeClass('d-none');
                    $('#fb-lock-data').addClass('d-none');
                    this.dataLocked = true;
                }
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });

    }
    toggleFeesBursaryData(e){
        if ($('#FB-fees-bursary-data-row').hasClass('d-none')){
            $('#FB-fees-bursary-data-row').removeClass('d-none');
        } else {
            $('#FB-fees-bursary-data-row').addClass('d-none');
        }
    }
    toggleHireBursaryData(e){
        if ($('#FB-hire-bursary-data-row').hasClass('d-none')){
            $('#FB-hire-bursary-data-row').removeClass('d-none');
        } else {
            $('#FB-hire-bursary-data-row').addClass('d-none');
        }
    }
    openSingleHandedStdDialog(e){
        if (!this.dataLocked)
            $('#FB-single-std').dialog('open');
    }
    openSingleHandedSubDialog(e){
        if (!this.dataLocked)
            $('#FB-single-sub').dialog('open');
    }
    openDoubleHandedStdDialog(e){
        if (!this.dataLocked)
            $('#FB-double-std').dialog('open');
    }
    openBoatLoanDialog(e){
        if (!this.dataLocked)
            $('#FB-boat-loan').dialog('open');
    }
    openClubSubsidyDialog(e){
        if (!this.dataLocked)
            $('#FB-club-subsidy').dialog('open');
    }
    openOnlineFundsDialog(e){
        if (!this.dataLocked)
            $('#FB-online-funds').dialog('open');
    }
}
function updateServer(feeType, cancelledEntries, lateEntries, price1, price2 ){
    switch (feeType){
        case "SHSTD":
            var restData = {
                "EVENT-ID": $('#fee_analysis_event').data('event'),
                'FEE-TYPE': feeType,
                'CANCELLATIONS': cancelledEntries,
                'LATE-ENTRIES' : lateEntries
            };
            break;
        case "SHSUB":
            var restData = {
                "EVENT-ID": $('#fee_analysis_event').data('event'),
                'FEE-TYPE': feeType,
                'CANCELLATIONS': cancelledEntries,
                'LATE-ENTRIES' : lateEntries
            };
            break;
        case "DHSTD":
            var restData = {
                "EVENT-ID": $('#fee_analysis_event').data('event'),
                'FEE-TYPE': feeType,
                'CANCELLATIONS': cancelledEntries,
                'LATE-ENTRIES' : lateEntries
            };
            break;
        case "BOATLOAN":
            var restData = {
                "EVENT-ID": $('#fee_analysis_event').data('event'),
                'FEE-TYPE': feeType,
                'CANCELLATIONS': cancelledEntries,
                'LATE-ENTRIES' : lateEntries,
                'PRICE' : price1
            };
            break;
        case "SUBSIDY":
            var restData = {
                'EVENT-ID': $('#fee_analysis_event').data('event'),
                'FEE-TYPE': feeType,
                'SUBSIDY' : price1
            };
            break;
        case "ONLINE":
            var restData = {
                'EVENT-ID': $('#fee_analysis_event').data('event'),
                'FEE-TYPE': feeType,
                'DYS-ONLINE' : price1,
                'CLUB-ONLINE' : price2
            };
            break;
        }
        $.ajax({
            beforeSend:(xhr) => {
                xhr.setRequestHeader('X-WP-Nonce',dysData.nonce);
            },
            url: dysData.root_url + '/wp-json/dys/v1/entriesChanged/',
            data: restData,
            type: 'POST',
            success: (response) =>{
                location.replace(location.href);
            },
            error: (response) => {
                console.log("Invalid Data Response");
                console.log(response);
            }
        });
}
function validateInputs(cancelledBox, lateEntriesBox, priceBox1, priceBox2){
    var regexQty = /^[0-9]*$/;
    var regexPrice = /^[£]?[0-9]*\.?[0-9]{0,2}$/;
    var valid = true;
    if (cancelledBox !=''){
        if (cancelledBox.val() == ''){
            cancelledBox.val('0');
        }
        cancelledBox.removeClass( "ui-state-error" );
        if (regexQty.test(cancelledBox.val())){
            valid = valid && true;
        } else {
            cancelledBox.addClass( "ui-state-error" );
            valid = false;
        }
    }
    if (lateEntriesBox !=''){
        if (lateEntriesBox.val() == ''){
            lateEntriesBox.val('0');
        }
        lateEntriesBox.removeClass( "ui-state-error" );
        if (regexQty.test(lateEntriesBox.val())){
            valid = valid && true;
        } else {
            lateEntriesBox.addClass( "ui-state-error" );
            valid = false;
        }
    }
    
    if (priceBox1 != ''){
        priceBox1.removeClass( "ui-state-error" );
        if (regexPrice.test(priceBox1.val())){
            valid = valid && true;
        } else {
            priceBox1.addClass( "ui-state-error" );
            valid = false;
        }
    }
    if (priceBox2 != ''){
        priceBox2.removeClass( "ui-state-error" );
        if (regexPrice.test(priceBox2.val())){
            valid = valid && true;
        } else {
            priceBox2.addClass( "ui-state-error" );
            valid = false;
        }
    }
    return valid;
}
export default FeeAnalysis;